import type { CuratedStory } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface CarouselDefaultIntegrityProps {
    items?: CuratedStory[];
}

export default function integrityCheck({
    items = [],
}: CarouselDefaultIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items, ["headline", "url"]);
}
